import type { PageGroup } from '@st/sdk'

export function titledPageGroups(groups: PageGroup[]): PageGroup[] {
  return groups
    .flatMap((group) => [group, ...titledPageGroups(group.children ?? [])])
    .filter((group) => Boolean(group.title?.trim()))
}
